import React from 'react'

import { Wrapper, Svg } from './styles'

import VibeLogo from '../VibeLogo'

const Vibing = props => {
    console.count('VibingSvg Component')

    const id = `filter-${props.uuid}`

    const vibingProps = {
        ...props,
        className: 'vibing',
        'data-testid': `vibing-${props.uuid}`,
    }

    return (
        <Wrapper {...vibingProps}>
            <VibeLogo id={id} />
        </Wrapper>
    )
}

export default Vibing
